<template>
  <div v-if="total > 0">
    <button
      type="button"
      class="flex w-full items-center gap-3 rounded-xl border border-yellow-200 bg-yellow-50 px-4 py-3 text-left"
      :aria-expanded="open"
      data-test="alerts-summary"
      @click="open = !open"
    >
      <ExclamationCircleIcon class="h-5 w-5 shrink-0 text-yellow-500" aria-hidden="true" />
      <span class="text-sm font-semibold text-yellow-900" data-test="alerts-total">{{ t("alerts_count", total) }}</span>
      <span
        v-for="chip in chips"
        :key="chip.name"
        class="rounded-full px-2.5 py-0.5 text-sm"
        :class="chip.name === 'fraud' ? 'bg-red-100 text-red-700' : 'bg-yellow-100 text-yellow-800'"
        :data-test="`alerts-chip-${chip.name}`"
      >
        {{ t(`chip.${chip.name}`, chip.count) }}
      </span>
      <span class="ml-auto flex shrink-0 items-center gap-2 text-sm text-yellow-800">
        {{ open ? t("hide_details") : t("show_details") }}
        <ChevronDownIcon class="h-4 w-4 transition-transform" :class="{ 'rotate-180': open }" aria-hidden="true" />
      </span>
    </button>
    <ClaimAlerts v-if="open" class="mt-3" :claim="claim" :customer="customer" />
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { ChevronDownIcon, ExclamationCircleIcon } from "@heroicons/vue/solid";
import ClaimAlerts from "@/components/claim/ClaimAlerts.vue";

const CATEGORIES = ["deadline", "coverage", "fraud"];

export default {
  name: "ClaimAlertsSummary",

  components: { ClaimAlerts, ChevronDownIcon, ExclamationCircleIcon },

  props: {
    claim: {
      type: Object,
      required: true,
    },
    customer: {
      type: Object,
      required: false,
    },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return { open: false };
  },

  computed: {
    chips() {
      const alerts = this.claim.alerts || [];
      const chips = CATEGORIES.map((name) => ({
        name,
        count: alerts.filter((alert) => alert.category === name).length,
      }));
      chips.find((chip) => chip.name === "fraud").count += this.claim.fraudSuspicion ? 1 : 0;
      chips.push({ name: "lcbft", count: this.customer?.lcbftScore ? 1 : 0 });

      return chips.filter((chip) => chip.count > 0);
    },

    total() {
      return this.chips.reduce((sum, chip) => sum + chip.count, 0);
    },
  },
};
</script>

<i18n src="./ClaimAlertsSummary.i18n.json"></i18n>
